import React, { useState } from "react";

import { mchenryServiceCoreUrl, useStore } from "mcmap-lib";

const sharedInputClasses =
  "h-7 w-20 text-black rounded-md text-xs mx-1 placeholder-gray-400";

const SalesUi = () => {
  const [isDate, setIsDate] = useState(true);
  const [isPrice, setIsPrice] = useState(true);
  const [minDate, setMinDate] = useState("");
  const [maxDate, setMaxDate] = useState("");
  const [minPrice, setMinPrice] = useState("");
  const [maxPrice, setMaxPrice] = useState("");

  React.useEffect(() => {
    const getFormattedDate = (dateStr) => {
      if (dateStr === "") return "null";
      const [year, month, day] = dateStr.split("-");
      return `${month}-${day}-${year}`;
    };
    const minDateFormatted = isDate ? getFormattedDate(minDate) : "null";
    const maxDateFormatted = isDate ? getFormattedDate(maxDate) : "null";
    const minPriceFormatted = isPrice && minPrice !== "" ? minPrice : "null";
    const maxPriceFormatted = isPrice && maxPrice !== "" ? maxPrice : "null";
    const baseUrl = `${mchenryServiceCoreUrl}/WedgeDevnetService.svc/rest/GetSales/`;
    const url = `${baseUrl}${minDateFormatted}/${maxDateFormatted}/${minPriceFormatted}/${maxPriceFormatted}/`;
    const state = useStore.getState();
    state.setSalesUrl(url);
  }, [isDate, isPrice, minDate, maxDate, minPrice, maxPrice]);

  return (
    <div className="flex items-center ">
      <div className="flex flex-col mr-4">
        <label className="flex">
          <input
            type="checkbox"
            checked={isDate}
            onChange={() => setIsDate((prev) => !prev)}
          />
          <span className="text-xs ml-1 font-semibold">Date</span>
        </label>
        <label className="flex">
          <input
            type="checkbox"
            checked={isPrice}
            onChange={() => setIsPrice((prev) => !prev)}
          />
          <span className="text-xs ml-1 font-semibold">Price</span>
        </label>
      </div>
      {isDate && (
        <>
          <input
            type="date"
            placeholder="MM/DD/YYYY"
            className={`${sharedInputClasses} w-24`}
            value={minDate}
            onChange={(e) => setMinDate(e.target.value)}
          />
          <span className="text-xs">to</span>
          <input
            type="date"
            placeholder="MM/DD/YYYY"
            className={`${sharedInputClasses} w-24`}
            value={maxDate}
            onChange={(e) => setMaxDate(e.target.value)}
          />
        </>
      )}
      {isPrice && (
        <>
          <input
            type="number"
            min={0}
            value={minPrice}
            placeholder="$ No Min"
            className={`${sharedInputClasses}`}
            onChange={(e) => setMinPrice(e.target.value)}
          />
          <span className="text-xs">to</span>
          <input
            type="number"
            min={0}
            value={maxPrice}
            placeholder="$ No Max"
            className={`${sharedInputClasses}`}
            onChange={(e) => setMaxPrice(e.target.value)}
          />
        </>
      )}
    </div>
  );
};
export default SalesUi;
